export default __webpack_public_path__ + "static/67479514_124135251911329_8706822914597570435_n-d9244f27d5a77e17c14c3576b6f14a54.jpg";